import React from 'react';
import './OrganizersSection.css';

const organizers = [
  { img: '/images/organizer-elsevier.png', id: 'elsevier', alt: 'Organizer 1', url: 'https://www.elsevier.com' },
  { img: '/images/organizer-uq.png', id: 'uq', alt: 'Organizer 2', url: 'https://www.uq.edu.au' }
];

const OrganizersSection = () => {
  return (
    <section className="organizers section fade-in-up" id="organizers">
      <div className="container">
        <h2 className="section-title" id="organizer-title">Organizers</h2>
        <div className="organizer-cards">
          {organizers.map((org, i) => (
            <div key={i} className="organizer-card">
              <a href={org.url} target="_blank" rel="noopener noreferrer">
                <img src={org.img} alt={org.alt} id={org.id} />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OrganizersSection;
